import React from "react";
import { useNavigate } from "react-router-dom";

// ===============================
// PortailService.jsx
// ===============================
// Portail générique du service (accueil)
// - Entrée Médecins
// - Entrée Responsable
// - Ne casse rien : c'est une page ajoutée, accessible via /portail
// ===============================

export default function PortailService() {
  const navigate = useNavigate();

  const S = {
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background:
        "linear-gradient(135deg, #eef2ff 0%, #f9fafb 40%, #ecfeff 100%)",
      fontFamily:
        "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      padding: "24px",
    },
    card: {
      maxWidth: "900px",
      width: "100%",
      background: "#ffffff",
      borderRadius: "24px",
      padding: "32px 32px 28px",
      boxShadow: "0 18px 45px rgba(15,23,42,0.18)",
      border: "1px solid #e5e7eb",
    },
    title: {
      fontSize: "32px",
      fontWeight: 800,
      marginBottom: "6px",
      color: "#111827",
    },
    subtitle: {
      fontSize: "16px",
      color: "#4b5563",
      marginBottom: "18px",
      lineHeight: 1.5,
      maxWidth: "720px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "18px",
      marginTop: "10px",
    },
    btn: {
      padding: "22px 20px",
      borderRadius: "18px",
      border: "1px solid #111827",
      background: "#111827",
      color: "#ffffff",
      cursor: "pointer",
      fontSize: "18px",
      fontWeight: 800,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      boxShadow: "0 10px 30px rgba(15,23,42,0.22)",
      transition: "transform 0.12s ease, box-shadow 0.12s ease",
    },
    btnLight: {
      background: "#ffffff",
      color: "#111827",
      border: "1px solid #d1d5db",
      boxShadow: "0 8px 22px rgba(148,163,184,0.35)",
    },
    btnTitle: {
      fontSize: "20px",
      fontWeight: 900,
    },
    btnDesc: {
      fontSize: "14px",
      fontWeight: 600,
      opacity: 0.9,
      lineHeight: 1.45,
    },
    footer: {
      marginTop: "18px",
      fontSize: "13px",
      color: "#6b7280",
    },
    mail: {
      color: "#111827",
      fontWeight: 800,
      textDecoration: "none",
    },
  };

  return (
    <div style={S.container}>
      <div style={S.card}>
        <h1 style={S.title}>Portail – Anesthésie Cochin–Port-Royal</h1>
        <p style={S.subtitle}>
          Accès médecins (désidératas / listes) et accès responsable. <br />
          Si vous n’êtes pas dans la liste : contactez{" "}
          <a style={S.mail} href="mailto:christophe.baillard@aphp.fr">
            christophe.baillard@aphp.fr
          </a>
          .
        </p>

        <div style={S.grid}>
          <button
            type="button"
            style={S.btn}
            onClick={() => navigate("/medecin")}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 14px 38px rgba(15,23,42,0.30)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 30px rgba(15,23,42,0.22)";
            }}
          >
            <span style={S.btnTitle}>🩺 Accès médecins</span>
            <span style={S.btnDesc}>
              Saisie des désidératas (gardes) et consultation des listes validées.
            </span>
          </button>

          <button
            type="button"
            style={{ ...S.btn, ...S.btnLight }}
            onClick={() => navigate("/responsable")}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 14px 34px rgba(148,163,184,0.45)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 22px rgba(148,163,184,0.35)";
            }}
          >
            <span style={S.btnTitle}>👤 Accès responsable</span>
            <span style={S.btnDesc}>
              Gestion planning / gardes / règles / équipe.
            </span>
          </button>
        </div>

        <div style={S.footer}>
          Portail générique du service (URL : /portail). Le flux médecins actuel reste accessible
          (route /).
        </div>
      </div>
    </div>
  );
}
